import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilsService } from 'src/app/services/tools/utils.service';

export interface BreakDownDetailsData {
  month : any;
}

@Component({
  selector: 'app-rates-breakdown',
  templateUrl: './rates-breakdown.component.html',
  styleUrls: ['./rates-breakdown.component.scss']
})

export class RatesBreakdownComponent implements OnInit {

  public toShow!: any;

  constructor(public dialogRef: MatDialogRef<BreakDownDetailsData>, public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: BreakDownDetailsData, public utils: UtilsService) { }

  ngOnInit(): void {
    this.toShow = this.data.month;
  }

  public niceDate(dd: string): string{
    return this.utils.getNiceDate(dd);
  }

}
